import isAbsoluteUrl from './is-absolute-url';
import { resolve } from './relative-to-absolute';

var resolveUrl = function resolveUrl(_ref) {
  var _ref$relative = _ref.relative,
      relative = _ref$relative === void 0 ? '' : _ref$relative,
      base = _ref.base;

  if (isAbsoluteUrl(relative)) {
    return relative;
  }

  if (!base) {
    var origin = window.location.origin;
    base = origin + "/";
  }

  return resolve(relative, base);
};

export { isAbsoluteUrl };
export default resolveUrl;